/**
 * Formata o telefone.
 * @param value Valor de entrada.
 * @returns Valor formatado.
 */
export const FormataTelefone = (value: string): string => {
  if (!value) return value;

  // Remove todos os caracteres que não sejam dígitos
  const cleaned = value.replace(/\D/g, '');

  // Formato para telefones fixos com DDD
  if (cleaned.length === 10)
    return cleaned.replace(/^(\d{2})(\d{4})(\d{4})$/, '($1) $2-$3');
  // Formato para celulares com DDD
  else if (cleaned.length === 11)
    return cleaned.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3');
  // Formato para telefone fixo sem DDD
  else if (cleaned.length === 8)
    return cleaned.replace(/^(\d{4})(\d{4})$/, '$1-$2');
  // Formato para celular sem DDD
  else if (cleaned.length === 9)
    return cleaned.replace(/^(\d{5})(\d{4})$/, '$1-$2');

  return cleaned.replace(/[^0-9()\-\s]/g, '');
};
